/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import PortalIdParser from 'PortalIdParser';
import { MSG_TYPE_MODAL_DIALOG_CLOSE } from 'ui-addon-iframeable/messaging/IFrameMessageTypes';
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
const PRELOAD_DELAY_MS = 8000; // keep in sync with SocialUI/lib/constants

const COMPOSER_WIDTH = 800;
export const COMPOSER_MESSAGE_TYPES = {
  ready: 'hs_composeready',
  loadComposeParams: 'loadComposeParams',
  exit: 'hs_socialexit',
  requestComposerClose: 'hs_requestComposerClose'
};
const PASSTHRU_PROPS = ['clientTag', 'body', 'link', 'photoUrl', 'channelType', 'remoteContentId', 'remoteContentType', 'campaignGuid', 'blogPost', 'quotedStatusUrl'];
const LOCAL_IFRAME_KEY = 'COMPOSER_ENV';

const getIframeSrcHost = () => {
  const host = window.location.host;

  if (localStorage.getItem(LOCAL_IFRAME_KEY)) {
    return host;
  }

  return host.includes('local') ? host.replace('local', 'app') : host;
};

const getIframeSrc = portalId => {
  const pathName = `/social-composer/${portalId}`;
  return `https://${getIframeSrcHost()}${pathName}?source=social-composer-lib`;
};

export default class SocialComposerPanel extends PureComponent {
  constructor(props) {
    super(props);

    this._preload = () => {
      if (this.initialized) {
        return;
      }

      this.setState({
        preload: true
      });
      this.preloadTimer = null;
    };

    this.handleOnReady = hostContext => {
      this.hostContext = hostContext;

      if (!this.initialized) {
        this.sendInitMessage();
      }
    };

    this.handleOnMessage = message => {
      const {
        payload: {
          type
        }
      } = message;

      if (type === MSG_TYPE_MODAL_DIALOG_CLOSE) {
        this.onCloseModal();
      }

      if (type === COMPOSER_MESSAGE_TYPES.exit) {
        if (this.props.onPublish && message.payload) {
          this.props.onPublish(message.payload);
        }
      }
    };

    this.handleClose = messagePayload => {
      this.initialized = false;

      if (this.props.onPublish && messagePayload) {
        this.props.onPublish(messagePayload);
      }

      this.props.onCloseModal();
    };

    this.state = {
      preload: props.preload
    };
  }

  componentDidMount() {
    if (this.props.preloadWithDelay) {
      this.preloadTimer = setTimeout(this._preload, PRELOAD_DELAY_MS);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.initialized = false;

      if (this.state.preload) {
        if (this.preloadTimer) {
          clearTimeout(this.preloadTimer);
        }

        this.sendInitMessage();
      }
    }

    if (this.props.preload && !prevProps.preload) {
      this.setState({
        preload: true
      });
    }
  }

  sendInitMessage() {
    if (!this.hostContext) {
      return;
    }

    const composerParams = {};
    PASSTHRU_PROPS.forEach(propName => {
      if (this.props[propName]) {
        composerParams[propName] = this.props[propName];
      }
    });

    if (this.props.cloningBroadcastGuid) {
      composerParams.cloning = true;
      composerParams.broadcastGuid = this.props.cloningBroadcastGuid;
    } else if (this.props.broadcastGuid) {
      composerParams.broadcastGuid = this.props.cloningBroadcastGuid;
    }

    this.hostContext.sendMessage(COMPOSER_MESSAGE_TYPES.loadComposeParams, composerParams);
    this.initialized = true;
  }

  render() {
    const {
      open
    } = this.props;
    const portalId = this.props.portalId || PortalIdParser.get();
    const url = getIframeSrc(portalId);
    return /*#__PURE__*/_jsx(UIModalIFrame, {
      appName: "social-composer",
      name: "social-composer",
      dialogClassName: "social-composer-panel",
      iframePassthruProps: {
        'data-test-id': 'social-composer-panel',
        id: 'social_composer_panel'
      },
      use: "sidebar",
      height: "100%",
      width: COMPOSER_WIDTH,
      preload: this.state.preload,
      showLoadingIndicator: true,
      show: open,
      src: url,
      onReady: this.handleOnReady,
      onMessage: this.handleOnMessage,
      onClose: this.handleClose,
      onEsc: this.handleClose
    });
  }

}
SocialComposerPanel.propTypes = {
  // iframeable related props
  open: PropTypes.bool.isRequired,
  // preloading is better UX but do not want to do it immediately in order to let the host page finish loading as ASAP
  preload: PropTypes.bool.isRequired,
  preloadWithDelay: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onPublish: PropTypes.func,
  // defaults to PortalIdParser, but override needed for chrome extension
  portalId: PropTypes.number,
  // props passed to composer via loadComposeParams
  clientTag: PropTypes.string.isRequired,
  // identifies host app and is saved on broadcast
  body: PropTypes.string,
  link: PropTypes.string,
  photoUrl: PropTypes.string,
  channelType: PropTypes.string,
  campaignGuid: PropTypes.string,
  remoteContentId: PropTypes.string,
  remoteContentType: PropTypes.string,
  broadcastGuid: PropTypes.string,
  cloningBroadcastGuid: PropTypes.string,
  quotedStatusUrl: PropTypes.string,
  blogPost: PropTypes.object
};
SocialComposerPanel.defaultProps = {
  preload: false,
  preloadWithDelay: false
};